import React, { useEffect, useState } from 'react';
import { AlertTriangle, Clock, EyeOff, FileText, FlaskConical } from 'lucide-react';
import { Section } from './Shared';
import { FeatherQuill, MoonPhase } from './HealingIcons';
import { Pricing } from './Pricing';
const LaunchUrgency = () => {
  const [timeLeft, setTimeLeft] = useState({
    h: 22,
    m: 47,
    s: 34
  });
  const [spotsTaken, setSpotsTaken] = useState(() => {
    const saved = typeof window !== 'undefined' ? sessionStorage.getItem('akashico-launch-spots') : null;
    if (saved) {
      const {
        value,
        timestamp
      } = JSON.parse(saved);
      const elapsed = (Date.now() - timestamp) / 1000;
      const increment = Math.floor(elapsed / 60);
      return Math.min(value + increment, 92);
    }
    return 92;
  });
  useEffect(() => {
    sessionStorage.setItem('akashico-launch-spots', JSON.stringify({
      value: spotsTaken,
      timestamp: Date.now()
    }));
  }, [spotsTaken]);
  useEffect(() => {
    const id = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) s--;else {
          s = 59;
          if (m > 0) m--;else {
            m = 59;
            if (h > 0) h--;
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(id);
  }, []);
  useEffect(() => {
    const id = setInterval(() => {
      setSpotsTaken(prev => {
        if (prev >= 98) return prev;
        return Math.random() < 0.4 ? prev + 1 : prev;
      });
    }, 45000 + Math.random() * 30000);
    return () => clearInterval(id);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  const TimeBox = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-231">
      <div className="bg-brand-goldDark text-white font-mono font-bold text-2xl md:text-4xl rounded-xl px-3 md:px-5 py-2 md:py-3 min-w-[56px] md:min-w-[80px] text-center shadow-md tabular-nums border border-brand-gold/40" data-id="element-232">
        {fmt(value)}
      </div>
      <span className="text-[10px] md:text-sm font-medium text-brand-text/70 mt-1.5 uppercase tracking-wider" data-id="element-233">
        {label}
      </span>
    </div>;
  return <div className="max-w-4xl mx-auto mb-12" data-id="element-234">
      <div className="glass-panel rounded-3xl p-6 md:p-8 border-2 border-brand-gold/40 bg-gradient-to-br from-white/95 to-brand-goldLight/10 shadow-[0_10px_40px_rgba(212,175,55,0.12)]" data-id="element-235">
        <div className="flex items-center justify-center gap-2 mb-5" data-id="element-236">
          <Clock className="w-5 h-5 md:w-6 md:h-6 text-brand-goldDark shrink-0" data-id="element-237" />
          <h3 className="font-serif font-bold text-base md:text-xl text-brand-darkGreen text-center" data-id="element-238">
            ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
          </h3>
        </div>

        <div className="flex items-center justify-center gap-2 md:gap-4 mb-5" data-id="element-239">
          <TimeBox value={timeLeft.h} label="Horas" data-id="element-240" />
          <span className="text-2xl md:text-4xl font-bold text-brand-gold/60 pb-5" data-id="element-241">
            :
          </span>
          <TimeBox value={timeLeft.m} label="Min" data-id="element-242" />
          <span className="text-2xl md:text-4xl font-bold text-brand-gold/60 pb-5" data-id="element-243">
            :
          </span>
          <TimeBox value={timeLeft.s} label="Seg" data-id="element-244" />
        </div>

        <div className="flex items-center justify-center gap-2 bg-amber-50 border border-amber-300/60 rounded-xl px-4 py-3 mb-6" data-id="element-245">
          <AlertTriangle className="w-4 h-4 md:w-5 md:h-5 text-amber-600 shrink-0" data-id="element-246" />
          <p className="text-sm md:text-base font-semibold text-amber-900 text-center" data-id="element-247">
            Después aumenta.{' '}
            <span className="text-brand-goldDark" data-id="element-248">
              No sabemos cuándo volverá esta oferta.
            </span>
          </p>
        </div>

        <div className="bg-white/80 rounded-2xl p-4 md:p-5 border border-brand-gold/30" data-id="element-249">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 mb-3" data-id="element-250">
            <div className="flex items-center gap-2" data-id="element-251">
              <span className="relative flex h-2.5 w-2.5" data-id="element-252">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-brand-error opacity-75" data-id="element-253"></span>
                <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-brand-error" data-id="element-254"></span>
              </span>
              <span className="font-semibold text-sm md:text-base text-brand-text" data-id="element-255">
                Cupos al precio de lanzamiento
              </span>
            </div>
            <span className="text-xs md:text-sm font-bold text-brand-goldDark uppercase tracking-wide" data-id="element-256">
              Quedan pocos
            </span>
          </div>

          <div className="w-full bg-brand-gold/15 rounded-full h-2.5 overflow-hidden mb-2" data-id="element-257">
            <div className="bg-gradient-to-r from-brand-gold to-brand-goldDark h-2.5 rounded-full transition-all duration-1000 ease-out" style={{
            width: `${spotsTaken}%`
          }} data-id="element-258" />
          </div>

          <p className="text-xs md:text-sm text-brand-text/70 text-center" data-id="element-259">
            🔥 <strong className="text-brand-goldDark" data-id="element-260">{spotsTaken}%</strong> de
            los cupos promocionales ya fueron tomados
          </p>
        </div>
      </div>
    </div>;
};
const tratadoFeatures = ['✅ Diagnóstico Preciso: Detectá qué bloquea tu dinero (envidia, energía pesada o deudas).', '✅ Limpieza de Almacén: Eliminá larvas energéticas sin gastar un peso en santerías.', '✅ Blindaje 360°: Protegé tu hogar, negocio y billetera de la envidia y el "ojeo".', '✅ Activación de riqueza: Convertí tu casa en un imán de oportunidades y clientes.', '✅ Corte de Raíz: Eliminá los mandatos de pobreza familiares y heredados.', '✅ Protocolo 48hs: Acciones de emergencia para destrabar pagos y atraer liquidez.'];
const bonuses = [{
  icon: FileText,
  title: 'LA BÓVEDA DE LOS SIGILOS DIGITALES',
  pages: '01 GRATIS',
  color: 'text-brand-goldDark',
  bgColor: 'bg-brand-gold/10',
  borderColor: 'border-brand-gold/30',
  image: 'https://cdn.magicpatterns.com/uploads/c4S7dJj4xBR49nL7igZ9gW/bonus_1.png',
  desc: 'Blindá tu celular para atraer notificaciones de cobro.',
  result: '✅ 12 Sigilos de Alta Frecuencia listos para usar.',
  price: '$8.500'
}, {
  icon: FlaskConical,
  title: 'GUÍA RÁPIDA: SAHUMADO DE ALMACÉN',
  pages: '02 GRATIS',
  color: 'text-brand-goldDark',
  bgColor: 'bg-brand-gold/10',
  borderColor: 'border-brand-gold/30',
  image: 'https://cdn.magicpatterns.com/uploads/p6mHv2T7bJd8ZJuSm3ABrE/bonus2.png',
  desc: 'Aprendé el ritual del café, la canela y otros elementos cotidianos.',
  result: '✅ 7 recetas de sahumado para distintas urgencias.',
  price: '$6.500'
}, {
  icon: EyeOff,
  title: 'EL ESCUDO DE SAN JORGE PARA EL HOGAR',
  pages: '03 GRATIS',
  color: 'text-brand-goldDark',
  bgColor: 'bg-brand-goldLight/10',
  borderColor: 'border-brand-goldLight/40',
  image: 'https://cdn.magicpatterns.com/uploads/mAcC8Mep3ZRTbp1Zaprb3R/bonus3.png',
  desc: 'Sellá puertas y ventanas para proteger tu hogar.',
  result: '✅ Técnica de sellado de las 4 esquinas.',
  price: '$7.500'
}];
const planComparison = [{
  situation: 'Tu casa tiene energía pesada',
  without: 'No sabés cómo limpiarla',
  with: 'Tenés el protocolo completo',
  with2: 'Tenés el protocolo completo',
  with3: 'Tenés el protocolo completo'
}, {
  situation: 'La envidia te frena',
  without: 'No tenés protección',
  with: 'Tu hogar está blindado',
  with2: 'Tu hogar está blindado',
  with3: 'Tu hogar está blindado'
}, {
  situation: 'El dinero no fluye',
  without: 'Seguís esperando',
  with: 'Activás el flujo en tu hogar',
  with2: 'Activás el flujo en tu hogar y billetera',
  with3: 'Activás todos los canales de ingreso'
}, {
  situation: 'Gastos imprevistos constantes',
  without: 'Sin herramientas',
  with: 'Protocolo de emergencia 48hs',
  with2: 'Protocolo de emergencia 48hs',
  with3: 'Protocolo de emergencia 48hs'
}, {
  situation: 'Mandatos de pobreza familiar',
  without: 'Sin solución',
  with: 'Técnica de corte energético',
  with2: 'Técnica de corte energético',
  with3: 'Genealogía energética profunda'
}, {
  situation: 'Querés expandir tus ingresos',
  without: 'No sabés por dónde empezar',
  with: 'Base sólida de limpieza',
  with2: 'Reprogramación mental diaria',
  with3: 'Sistema maestro de expansión'
}];
export const MethodOverview = () => {
  return <Section id="method" className="relative" data-id="element-261">
      <FeatherQuill className="hidden lg:block absolute top-20 right-[3%] w-8 h-8 opacity-25 animate-float-soft" color="#D4AF37" style={{
      transform: 'rotate(-15deg)'
    }} data-id="element-262" />
      <MoonPhase className="hidden lg:block absolute top-60 left-[2%] w-10 h-10 opacity-30 animate-float-soft" color="#A07C1E" style={{
      transform: 'rotate(12deg)',
      animationDelay: '1.5s'
    }} data-id="element-263" />

      <div className="text-center mb-12" data-id="element-264">
        <div className="inline-flex items-center space-x-2 bg-white border border-brand-gold/40 px-4 py-1.5 rounded-full mb-6 shadow-sm" data-id="element-265">
          <span className="text-xl" data-id="element-266">🏆</span>
          <span className="font-serif font-semibold tracking-wider text-brand-goldDark text-sm md:text-base" data-id="element-267">
            CÓDIGO DE BLINDAJE ARGENTINO™
          </span>
        </div>
        <h2 className="text-2xl md:text-5xl font-display font-bold mb-4 leading-tight text-brand-darkGreen" data-id="element-268">
          El sistema completo de limpieza energética, protección contra la
          envidia y apertura de caminos financieros.
        </h2>
        <p className="text-brand-text/70 md:text-lg text-[13px]" data-id="element-269">
          Todo lo que necesitás para cortar la mala racha, blindar tu hogar y
          activar el flujo de dinero usando elementos simples que ya tenés en tu
          casa.
        </p>
      </div>

      <div className="max-w-5xl mx-auto mb-12 space-y-6" data-id="element-270">
        <div className="rounded-2xl p-6 md:p-8 border bg-brand-darkGreen/5 border-brand-darkGreen/30 backdrop-blur-sm shadow-sm" data-id="element-271">
          <div className="flex flex-col md:flex-row md:items-start gap-4 md:gap-6" data-id="element-272">
            <div className="shrink-0 mx-auto md:mx-0 w-32 md:w-40 flex items-center justify-center" data-id="element-273">
              <img src="https://cdn.magicpatterns.com/uploads/4tpaUXDF4tSgVsbF9kYjzP/tomo.png" alt="Código de Blindaje Argentino" className="w-full h-auto max-h-[240px] object-contain rounded-md drop-shadow-xl" data-id="element-274" />
            </div>
            <div className="flex-grow" data-id="element-275">
              <h4 className="font-serif font-bold mb-2 text-lg text-brand-darkGreen" data-id="element-276">
                📘 CÓDIGO DE BLINDAJE ARGENTINO™
              </h4>
              <p className="text-brand-text/90 font-medium mb-2 text-[15px]" data-id="element-277">
                El sistema paso a paso para cortar la mala racha, proteger tu
                hogar y volver a abrir el camino del dinero.
              </p>
              <p className="text-brand-text mb-4 text-[12px]" data-id="element-278">
                El sistema definitivo diseñado para la realidad del argentino de
                hoy. Aprendé a identificar y eliminar los bloqueos que frenan tu
                economía usando lo que ya tenés en tu casa.
              </p>

              <div className="bg-white/80 p-4 rounded-lg border border-brand-gold/15 mb-4" data-id="element-279">
                <p className="text-xs font-bold uppercase tracking-wider text-brand-goldDark mb-3" data-id="element-280">
                  ¿QUÉ VAS A LOGRAR?
                </p>
                <div className="grid grid-cols-1 gap-x-3 gap-y-1.5 text-xs md:text-sm text-brand-text" data-id="element-281">
                  {tratadoFeatures.map((f, i) => <div key={i} className="flex items-center" data-id="element-282">
                      <span data-id="element-283">{f}</span>
                    </div>)}
                </div>
              </div>
              <p className="font-serif italic text-brand-goldDark text-sm" data-id="element-284">
                🌿 Porque las buenas intenciones no pagan cuentas. Primero
                limpiás el camino, después el dinero entra.
              </p>
            </div>
          </div>
        </div>

        <div className="text-center mb-8 mt-12" data-id="element-285">
          <h3 className="text-xl md:text-2xl font-serif font-bold text-brand-darkGreen" data-id="element-286">
            🎁 3 BONUS SAGRADOS
          </h3>
          <p className="text-xs md:text-sm uppercase tracking-wider text-brand-goldDark mt-1 font-bold" data-id="element-287">
            SIEMPRE INCLUIDOS SIN COSTO ADICIONAL
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-288">
          {bonuses.map((bonus, i) => {
          return <div key={i} className="glass-panel rounded-2xl p-5 border-brand-gold/30 relative overflow-hidden bg-white/90 flex flex-col" data-id="element-289">
                <div className={`absolute top-3 left-3 ${bonus.bgColor} border ${bonus.borderColor} ${bonus.color} text-[11px] md:text-sm font-mono font-bold px-2 py-0.5 rounded-md`} data-id="element-290">
                  {bonus.pages}
                </div>
                <div className="absolute top-0 right-0 bg-brand-gold text-brand-darkGreen text-xs md:text-sm font-bold px-3 py-1 rounded-bl-lg" data-id="element-291">
                  GRATIS
                </div>

                <img src={bonus.image} alt={bonus.title} className="w-36 md:w-40 mx-auto h-auto mt-10 mb-6 rounded-lg object-contain drop-shadow-xl ring-1 ring-brand-gold/20" data-id="element-292" />

                <h4 className="text-base font-serif font-bold mb-2 leading-tight text-brand-text" data-id="element-293">
                  {bonus.title}
                </h4>
                <p className="text-brand-text mb-3 text-xs flex-grow" data-id="element-294">
                  {bonus.desc}
                </p>
                <div className="text-xs font-medium text-brand-goldDark mb-2" data-id="element-295">
                  {bonus.result}
                </div>
                <div className="text-xs text-brand-text/50 mt-auto" data-id="element-296">
                  <span data-id="element-297">
                    Valor estimado:{' '}
                    <span className="line-through" data-id="element-298">{bonus.price}</span>
                  </span>
                  <span className="ml-2 font-bold text-brand-goldDark" data-id="element-299">
                    → GRATIS
                  </span>
                </div>
              </div>;
        })}
        </div>

        <div className="text-center mt-8" data-id="element-300">
          <div className="inline-block glass-panel px-6 py-3 rounded-full border-brand-gold/30 bg-white/80" data-id="element-301">
            <p className="text-sm md:text-base font-medium text-brand-text" data-id="element-302">
              🎁 Valor total de los bonus:{' '}
              <span className="line-through text-brand-text/50" data-id="element-303">$22.500</span>{' '}
              <span className="text-brand-goldDark font-bold" data-id="element-304">
                → Hoy incluidos GRATIS con tu compra.
              </span>
            </p>
          </div>
        </div>
      </div>

      <LaunchUrgency data-id="element-305" />
      <Pricing data-id="element-306" />

      <div className="max-w-5xl mx-auto mb-12 mt-12" data-id="element-307">
        <div className="bg-white rounded-2xl p-5 md:p-6 border border-brand-gold/30 shadow-sm overflow-x-auto" data-id="element-308">
          <p className="text-base md:text-lg font-semibold text-brand-darkGreen mb-4 text-center" data-id="element-309">
            🎓 ¿QUÉ AGREGA CADA NIVEL?
          </p>

          <div className="min-w-[600px]" data-id="element-310">
            <div className="grid grid-cols-5 gap-2 text-[11px] md:text-sm font-semibold uppercase tracking-wide text-brand-text/60 border-b border-brand-gold/20 pb-2 mb-2" data-id="element-311">
              <div className="col-span-2" data-id="element-312">Situación</div>
              <div className="text-brand-error" data-id="element-313">❌ Sin el Sistema</div>
              <div className="text-brand-goldDark" data-id="element-314">✅ Kit Esencial</div>
              <div className="text-brand-goldDark" data-id="element-315">⭐ Kit Avanzado</div>
              <div className="text-brand-goldDark" data-id="element-316">🌟 Combo de Oro</div>
            </div>
            <div className="space-y-2" data-id="element-317">
              {planComparison.map((row, i) => <div key={i} className="grid grid-cols-5 gap-2 text-xs md:text-sm text-brand-text py-1.5 border-b border-brand-gold/10 last:border-0" data-id="element-318">
                  <div className="font-medium col-span-2" data-id="element-319">{row.situation}</div>
                  <div className="text-brand-error/80" data-id="element-320">{row.without}</div>
                  <div className="text-brand-goldDark font-medium" data-id="element-321">
                    {row.with}
                  </div>
                  <div className="text-brand-goldDark font-medium" data-id="element-322">
                    {row.with2}
                  </div>
                  <div className="text-brand-goldDark font-medium" data-id="element-323">
                    {row.with3}
                  </div>
                </div>)}
            </div>
          </div>

          <p className="text-sm font-medium text-brand-goldDark italic text-center mt-5" data-id="element-324">
            🌿 Una sola oportunidad nueva puede recuperar la inversión completa.
          </p>
        </div>
      </div>
    </Section>;
};